import "core-js/modules/es.array.concat";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
var initForm = {
  auditDescription: '',
  rejectDescription: '',
  actualDeliveryStatus: 1,
  refundStatus: 2
};
export default {
  meta: {
    title: '服务单详情',
    auth: true,
    authorityValue: "store-cancel-manage"
  },
  name: 'cancelOrderDetail',
  data: function data() {
    return {
      title: '服务单详情',
      detailsData: {},
      form: cloneDeep(initForm),
      radioGroupStatus: [{
        label: '同意',
        value: 2
      }, {
        label: '驳回',
        value: 3
      }],
      contentStyle: {
        color: 'red'
      }
    };
  },
  filters: {
    consigneeInfo: function consigneeInfo(e) {
      if (!e) return;
      var consigneeName = e.consigneeName,
          consigneePhone = e.consigneePhone;
      return "".concat(consigneeName, "(").concat(consigneePhone, ")");
    }
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.cancelDetails(item);

              case 2:
                data = _context.sent;
                _this.detailsData = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onsubmit: function onsubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.form.refundStatus == 3 && !_this2.form.rejectDescription)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", _this2.$message.error('请输入驳回原因'));

              case 2:
                _context2.next = 4;
                return _this2.$api.audit(_objectSpread(_objectSpread({}, _this2.form), _this2.$route.query));

              case 4:
                YL.message('审核成功');

                _this2.goBack();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var query = this.$route.query;
    this.dataBind(query);
  }
};